import { FC } from "react";
import { useAppSelector } from "src/hooks/redux";
import { selectCurrentUserState } from "src/redux/currentUser/selector";
import { getImageUrl } from "src/utils/getImageUrl";
import { AuthButtons } from "./AuthButtons";
import { ProfileCard } from "./ProfileCard";
import { Menu } from "./Menu";
import { Logo } from "../Logo";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { useMediaQuery } from "react-responsive";

interface Props {
  isShown?: boolean;
}
export const Header: FC<Props> = ({ isShown = true }) => {
  const isGLScreenBreakpoint = useMediaQuery({
    maxWidth: SCREEN_BREAKPOINTS.GL,
  });

  const { currentUser, isAuthorized } = useAppSelector(selectCurrentUserState);

  if (!isShown || isGLScreenBreakpoint) return null;

  return (
    <header className="w-full fixed z-10 bg-white-pink shadow-light-bottom">
      <div className="container flex justify-between items-center h-19 capitalize font-medium !text-purple-base">
        <Logo isColored />
        <Menu />
        {isAuthorized && (
          <div className="flex justify-center items-center gap-10 fill-svg-purple-base">
            {/* <MessagesButton /> */}
            <ProfileCard
              fullName={`${currentUser.host.first_name} ${currentUser.host.last_name}`}
              avatarUrl={getImageUrl(currentUser.host.avatarUrl)}
            />
          </div>
        )}
        {!isAuthorized && <AuthButtons />}
      </div>
    </header>
  );
};
